import React from "react";
import type {PrintoutWritingAreaAttrs} from "./printoutWritingAreaOptions";

const WritingAreaView = ({attrs}: {attrs: PrintoutWritingAreaAttrs}) => (
    <div
        className="printout-writing-area-block"
        data-printout-writing-area-style={attrs.style}
        style={{
            "--printout-writing-area-height": `${attrs.heightMm}mm`,
        } as React.CSSProperties}
    >
        {attrs.label && (
            <div className="printout-writing-area-label">
                {attrs.label}
            </div>
        )}
        <div className="printout-writing-area-surface"/>
    </div>
);

export default WritingAreaView;
